<template>
  <v-card max-width="600">
    <!-- CARD TITLE -->
    <v-card-title class="mb-0 pb-0 grey lighten-3">
      <h1 class="title mb-2">
        Work Order #{{ workOrder.orderNumber
        }}<v-icon
          v-if="showClose"
          style="position:absolute;right:16px"
          @click="closeClicked()"
          >close</v-icon
        >
        <div class="grey--text font-weight-regular body-2">
          {{ workOrder.orderDate.toDate() | moment("MMM Do [at] h:mma") }}
          <v-chip x-small v-show="workOrder.status == 'cancelled'"
            >cancelled</v-chip
          >
          <v-chip
            color="red lighten-3"
            x-small
            v-show="workOrder.status == 'closed'"
            >closed</v-chip
          >
        </div>
      </h1>
    </v-card-title>
    <!-- CARD BODY -->
    <v-card-text class="pt-4">
      <!-- JOB DETAILS -->
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="px-0 pr-1">ADDRESS</td>
              <td class="px-0 pr-1">
                <strong>
                  {{ workOrder.jobSite.street }}
                  <span
                    class="font-weight-regular"
                    v-if="workOrder.jobSite.street2"
                  >
                    {{ workOrder.jobSite.street2 }}</span
                  >{{ workOrder.jobSite.city }}
                  {{ workOrder.jobSite.postalCode }}</strong
                >
              </td>
            </tr>
            <tr>
              <td class="px-0 pr-1">CLIENT</td>
              <td class="px-0 pr-1">
                <strong>{{ workOrder.client }}</strong>
              </td>
            </tr>

            <tr>
              <td class="px-0 pr-1">COMPLETED</td>
              <td class="px-0 pr-1">
                <strong>{{
                  workOrder.dateCompleted | moment("MM/DD/YYYY")
                }}</strong>
              </td>
            </tr>
            <tr>
              <td class="px-0 pr-1">SCOPE</td>
              <td class="px-0 pr-1">
                <strong>{{ workOrder.scopeCompleted }}</strong>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- LABOR & SERVICE -->
      <div class="mt-4 mb-4">
        <v-simple-table
          dense
          class="order-details-table mt-0"
          v-if="workOrder.labor.length"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="pa-1 text-left">Labor & Service</th>
                <th class="pa-1 text-right small-col">QTY</th>
                <th class="pa-1 text-right small-col">Hrs</th>
                <!-- <th width="20"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in workOrder.labor" :key="index">
                <td class="pa-1">
                  {{ row.type }}
                </td>
                <td class="pa-1 text-right">
                  {{ row.qty }}
                </td>
                <td class="pa-1 text-right">
                  {{ row.hours }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- PARTS & MATERIALS -->
      <div class="mt-4 mb-4">
        <v-simple-table
          dense
          class="order-details-table mt-0"
          v-if="workOrder.partsMaterials.length"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="pa-1 text-left">Parts & Materials</th>
                <th class="pa-1 text-left text-right small-col">QTY</th>
                <!-- <th width="20"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in workOrder.partsMaterials" :key="index">
                <td class="pa-1">
                  {{ row.title }}
                </td>
                <td class="pa-1 text-right">
                  {{ row.qty }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- DEBRIS REMOVAL -->
      <div class="mt-4 mb-4">
        <v-simple-table dense class="order-details-table mt-0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="pa-1 text-left">Debris Removal</th>
                <th class="pa-1 text-right small-col">QTY</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="pa-1">
                  Yardage
                </td>
                <td class="pa-1 text-right">
                  {{ workOrder.debrisYardage || 0 }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- FOREMAN SIGNATURE -->
      <div class="mt-4 mb-4">
        <div>
          FOREMAN: <strong>{{ workOrder.foremanPrintName }}</strong>
        </div>
        <v-img :src="workOrder.foremanSignatureImage" contain max-width="400" />
      </div>
      <!-- SIGNATURES - CLIENT -->
      <div class="mt-4 mb-4">
        <div>
          CLIENT: <strong>{{ workOrder.clientPrintName }}</strong>
        </div>
        <v-img :src="workOrder.clientSignatureImage" contain max-width="400" />
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ["workOrder", "showClose"],
  data() {
    return {};
  },
  methods: {
    closeClicked() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.small-col {
  width: 60px;
}
@media (min-width: 600px) {
  .small-col {
    width: 90px;
  }
}
thead tr {
  background: #f3f3f3;
}
</style>
